import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Forside', path: '/' },
    { name: 'Ydelser', path: '/ydelser' },
    { name: 'Om CARPA', path: '/om-carpa' },
    { name: 'Referencer', path: '/referencer' },
    { name: 'Kurser', path: '/kurser' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  const activeStyle = ({ isActive }) =>
    `relative py-2 text-sm font-semibold transition-colors duration-200 hover:text-[#3c8888] ${
      isActive ? 'text-[#3c8888] after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:bg-[#3c8888]' : 'text-[#0e1f2f]'
    }`;

  return (
    <header className="sticky top-0 z-40 w-full border-b border-[#0e1f2f]/10 bg-white/95 backdrop-blur-md shadow-sm">
      {/* Top Bar for contact info */}
      <div className="hidden sm:block border-b border-[#0e1f2f]/10 bg-[#0e1f2f] py-2.5 text-xs text-[#f7f8fa]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6">
          <div className="flex items-center gap-6">
            <a href="tel:+4553636223" className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap">
              <Phone className="h-3.5 w-3.5 text-[#3c8888]" />
              <span>+45 53 63 62 23</span>
            </a>
            <a href="mailto:llk@carpa.dk" className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap">
              <Mail className="h-3.5 w-3.5 text-[#3c8888]" />
              <span>llk@carpa.dk</span>
            </a>
          </div>
          <div className="text-slate-400 font-medium">
            CVR: 43293354 · Viborg
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl h-20 items-center justify-between px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 focus:outline-none">
          <img
            src="https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/nyt-logo.png"
            alt="CARPA ApS Logo"
            className="h-11 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden min-[1200px]:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={activeStyle}>
              {item.name}
            </NavLink>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden min-[1200px]:flex items-center">
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center rounded-md bg-[#0e1f2f] px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-all duration-200 hover:bg-[#0e1f2f]/90 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#0e1f2f]/50 border-b-2 border-[#3c8888]"
          >
            Book en afklarende samtale
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="rounded-md p-2 text-[#0e1f2f] hover:bg-[#f7f8fa] min-[1200px]:hidden focus:outline-none"
          aria-label="Skift menu"
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="min-[1200px]:hidden border-t border-[#0e1f2f]/10 bg-white px-6 py-6 space-y-4 shadow-inner">
          <nav className="flex flex-col space-y-3">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block rounded-md px-3 py-2 text-base font-semibold transition-colors ${
                    isActive ? 'bg-[#f7f8fa] text-[#3c8888]' : 'text-[#0e1f2f] hover:bg-[#f7f8fa]/50 hover:text-[#3c8888]'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>
          <div className="pt-4 border-t border-[#0e1f2f]/10 flex flex-col gap-4">
            <div className="space-y-2 text-sm text-[#0e1f2f] px-3">
              <a href="tel:+4553636223" className="flex items-center gap-2 hover:text-[#3c8888] transition-colors whitespace-nowrap">
                <Phone className="h-4 w-4 text-[#3c8888]" />
                <span className="font-medium">+45 53 63 62 23</span>
              </a>
              <a href="mailto:llk@carpa.dk" className="flex items-center gap-2 hover:text-[#3c8888] transition-colors whitespace-nowrap">
                <Mail className="h-4 w-4 text-[#3c8888]" />
                <span className="font-medium">llk@carpa.dk</span>
              </a>
            </div>
            <Link
              to="/kontakt"
              onClick={() => setIsOpen(false)}
              className="block w-full text-center rounded-md bg-[#0e1f2f] py-3 text-base font-bold text-white shadow-sm hover:bg-[#0e1f2f]/90 transition-colors border-b-2 border-[#3c8888]"
            >
              Book en afklarende samtale
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
